import { motion, useInView } from 'framer-motion'
import { useRef } from 'react'
import { cn } from '../lib/cn'

interface ProgressBarProps {
  value: number
  color?: string | undefined
  trackClassName?: string
  height?: number | undefined
  showLabel?: boolean
}

export function ProgressBar({ value, color = '#FC2265', trackClassName, height = 6, showLabel }: ProgressBarProps) {
  const ref = useRef<HTMLDivElement>(null)
  const inView = useInView(ref, { once: true, margin: '0px 0px -40px 0px' })
  const clamped = Math.max(0, Math.min(100, value))

  return (
    <div className="flex items-center gap-2 w-full">
      <div
        ref={ref}
        className={cn('w-full overflow-hidden rounded-full bg-shell-border', trackClassName)}
        style={{ height }}
      >
        <motion.div
          className="h-full rounded-full"
          style={{ backgroundColor: color }}
          initial={{ width: 0 }}
          animate={{ width: inView ? `${clamped}%` : 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        />
      </div>
      {showLabel && <span className="text-xs font-medium text-shell-text tabular-nums w-9 text-right">{clamped}%</span>}
    </div>
  )
}
